import { ReloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { createStyles } from 'antd-style'

import { AuctionModalHeaderProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  header: {
    fontWeight: 'normal',
    textAlign: 'center'
  },
  desc: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: token.paddingXS,
    padding: `${token.paddingXS}px 0`,
    margin: `${token.margin}px 0`,
    fontSize: token.fontSize,
    backgroundColor: token.colorBgLayout
  }
}))

export const AuctionModalHeader = ({
  tableRef,
  title,
  desc
}: AuctionModalHeaderProps) => {
  const { styles } = useStyles()

  return (
    <div className={styles.header}>
      <div>{title}</div>
      <div className={styles.desc}>
        {desc}
        <Button size='small' type='text'>
          <ReloadOutlined onClick={() => tableRef.current?.reload()} />
        </Button>
      </div>
    </div>
  )
}
